/**
 * @generated SignedSource<<20c382f598437766ffa9788e20128bed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TextRenderer_question$data = {
  readonly id: string;
  readonly options: ReadonlyArray<{
    readonly label: string;
    readonly sublabel: string | null | undefined;
    readonly value: string;
  }>;
  readonly " $fragmentType": "TextRenderer_question";
};
export type TextRenderer_question$key = {
  readonly " $data"?: TextRenderer_question$data;
  readonly " $fragmentSpreads": FragmentRefs<"TextRenderer_question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TextRenderer_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Option",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sublabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "2033eaac0c92d8bcce5431ed71bc1e47";

export default node;
